import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[noEmoji]',
  standalone: true
})
export class NoEmojiDirective {
  // emojis using Unicode property escapes
  private emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;

  constructor(private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement | HTMLTextAreaElement;
    if (!input) return;

    const cleanValue = input.value.replace(this.emojiRegex, '');
    if (cleanValue !== input.value) {
      this.control.control?.setValue(cleanValue, { emitEvent: false });
    }
  }
}
